export enum PermissionTypes {
	GESTORI_SISTEMA = "gestori_sistema",
	PIANIFICATORI = "pianificatori",
	SCHEDULATORI = "schedulatori",
	COMMERCIALI = "commerciali",
	BKO_CLIENTI = "bko_clienti",
	BKO_FORNITORI = "bko_fornitori",
	LOGISTICA = "logistica",
	CONTABILI = "contabili",
	GRUPPO_UNDERCONSTRUCTION = "gruppo_underconstruction",
	TICKETING_ASSISTENZA = "ticketing_assistenza",
	TICKETING_UTENTI = "ticketing_utenti",
	GESTORI_IMPREVISTI =  "gestori_imprevisti",
	GESTORI_ROUTES =  "gestori_routes",
	OPERATORI_REPARTO = "operatori_reparto",
	ALL = "all",
}

// export const PROGRAMMA_INCASSETTAMENTO_PERMISSIONS = [
// 	PermissionTypes.PIANIFICATORI,
// 	PermissionTypes.OPERATORI_MACELLO,
// 	PermissionTypes.SCHEDULATORI_LAVORAZIONI,
// 	PermissionTypes.SCHEDULATORI_ESTERNI,
// ];
